export enum IntegrationModeEnum {
  Add,
  Edit,
}
